import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-discover-five',
  templateUrl: './discover-five.component.html',
  styleUrls: ['./discover-five.component.css']
})
export class DiscoverFiveComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
